import { useMeetingManager } from "amazon-chime-sdk-component-library-react";
import { useEffect } from "react";

export const useHeartbeat = () => {
  const meetingManager = useMeetingManager();

  useEffect(() => {
    // Keep the connection alive with heartbeat
    const heartbeatInterval = setInterval(() => {
      if (meetingManager.audioVideo && document.visibilityState === "hidden") {
        // Send a data message as a heartbeat to keep the connection alive
        meetingManager.audioVideo.realtimeSendDataMessage(
          "heartbeat",
          JSON.stringify({ timestamp: Date.now() }),
          1000
        );
      }
    }, 15000);

    return () => {
      clearInterval(heartbeatInterval);
    };
  }, [meetingManager]);
};
